export type UserManagementProfilesAction =
    | 'add'
    | 'edit'
    | 'assign-permissions'
    | 'assign-categories'
    | 'assign-views'
    | 'assign-tags'
    | 'detail';

export interface UserManagementProfilesRoute {
    action: UserManagementProfilesAction | null;
    id: number | null;
}

const BASE_PATH = '/user_management/profiles';

const VALID_ACTIONS: UserManagementProfilesAction[] = [
    'add',
    'edit',
    'assign-permissions',
    'assign-categories',
    'assign-views',
    'assign-tags',
    'detail',
];

export const buildUserManagementProfilesBasePath = (): string => BASE_PATH;

export const buildUserManagementProfilesActionPath = (
    action: UserManagementProfilesAction,
    id?: number | string | null
): string => {
    if (action === 'add') {
        return `${BASE_PATH}/add`;
    }

    if (id === undefined || id === null || id === '') {
        return BASE_PATH;
    }

    return `${BASE_PATH}/${action}/${id}`;
};

export const parseUserManagementProfilesRoute = (
    pathname: string
): UserManagementProfilesRoute => {
    const segments = pathname.split('/').filter(Boolean);

    if (segments[0] !== 'user_management' || segments[1] !== 'profiles') {
        return { action: null, id: null };
    }

    const action = segments[2] as UserManagementProfilesAction | undefined;
    if (!action || !VALID_ACTIONS.includes(action)) {
        return { action: null, id: null };
    }

    if (action === 'add') {
        return { action, id: null };
    }

    const rawId = segments[3];
    if (!rawId || !/^\d+$/.test(rawId)) {
        return { action: null, id: null };
    }

    return { action, id: Number(rawId) };
};